/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskMetricResult } from './RiskMetricResult';
import { RiskMetricResultFromJSON, RiskMetricResultFromJSONTyped, RiskMetricResultToJSON } from './RiskMetricResult';

/**
 *
 * @export
 * @interface PaginatedRiskMetricResultList
 */
export interface PaginatedRiskMetricResultList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskMetricResultList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskMetricResultList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskMetricResultList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskMetricResult>}
   * @memberof PaginatedRiskMetricResultList
   */
  results: Array<RiskMetricResult>;
}

/**
 * Check if a given object implements the PaginatedRiskMetricResultList interface.
 */
export function instanceOfPaginatedRiskMetricResultList(value: object): value is PaginatedRiskMetricResultList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskMetricResultListFromJSON(json: any): PaginatedRiskMetricResultList {
  return PaginatedRiskMetricResultListFromJSONTyped(json, false);
}

export function PaginatedRiskMetricResultListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskMetricResultList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskMetricResultFromJSON),
  };
}

export function PaginatedRiskMetricResultListToJSON(value?: PaginatedRiskMetricResultList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskMetricResultToJSON),
  };
}
